<template>
  <aside
    v-show="displayPanel"
    :id="id"
    role="region"
    aria-modal="true"
    data-testId="info-panel"
    :class="[infoPanel]"
    :aria-labelledby="ariaLabelledby"
    :aria-live="ariaLive"
    :aria-hidden="ariaHidden"
  >
    <header class="info-panel-header">
      <img
        id="info-panel-icon"
        loading="lazy"
        :src="infoPanelIcon"
        alt="The letter I enclosed in a circle"
      >
    </header>
    <div class="info-panel-message-container">
      <span
        v-if="hasNote"
        :class="{
          'info-panel-message-note-colon': colon,
          'info-panel-note': noteBold,
        }"
      >
        Note
      </span>
      <span
        :id="ariaLabelledby"
        class="info-panel-message"
      >
        <slot /><!-- pass html if needed -->
        {{ infoMessage }}<!-- pass string if needed -->
      </span>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'InfoPanel',
  props: {
    infoMessage: {
      type: String,
      default: '',
      requied: true,
    },
    colon: {
      type: Boolean,
      default: true,
    },
    ariaLive: {
      type: String,
      default: 'polite',
      validator: (value) => new Set(['assertive', 'polite', 'off']).has(value.toLowerCase()),
    },
    id: {
      type: String,
      default: '',
    },
    displayPanel: {
      type: Boolean,
      default: false,
    },
    ariaHidden: {
      type: Boolean,
      default: false,
    },
    hasNote: {
      type: Boolean,
      default: false,
    },
    infoType: {
      type: String,
      default: 'info',
    },
    noteBold: {
      type: Boolean,
      default: false,
    },
    img: {
      type: String,
      default: '',
    },
    panelType: {
      type: String,
      default: '',
    },
  },
  computed: {
    infoPanel() {
      return `info-panel-background-${this.infoType}`;
    },
    ariaLabelledby() {
      return `info-panel-message-${this.id}`;
    },
    infoPanelIcon() {
      switch (this.panelType) {
        case ('info'):
          return 'https://cdn.ampersend.io/2NyR0b1JOkSv7RJMjqk87ZBSKpG.png';
        default:
          return 'https://cdn.ampersend.io/20VeD5KEtOQmktkroNjEK1z53R9.png';
      }
    },
  },
};
</script>
